import type { Token } from './createToken';

export class Container {
  private dependencies = new Map<symbol, unknown>();

  register<T>(token: Token<T>, value: T): void {
    this.dependencies.set(token, value);
  }

  resolve<T>(token: Token<T>): T {
    if (!this.dependencies.has(token)) {
      const name = token.description ?? token.toString();
      throw new Error(
        `[travelata-frontend] Зависимость "${name}" не зарегистрирована в DI-контейнере. Вызови initLibrary() из хоста до использования библиотеки.`,
      );
    }
    return this.dependencies.get(token) as T;
  }

  has<T>(token: Token<T>): boolean {
    return this.dependencies.has(token);
  }

  reset(): void {
    this.dependencies.clear();
  }
}

export const container = new Container();
